import { useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/Card";
import { api } from "@/lib/api";
import { RefreshCw, CheckCircle2, XCircle } from "lucide-react";

export function SettingsPage() {
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState<{ synced: number; failed: number; total: number } | null>(null);
  const [syncError, setSyncError] = useState("");

  async function handleSyncOffers() {
    setSyncing(true);
    setSyncResult(null);
    setSyncError("");
    try {
      const res = await api.post("/v1/offers/sync-tracking", {});
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error((d as any).error || "Sync failed");
      }
      const data = await res.json() as any;
      setSyncResult({ synced: data.synced, failed: data.failed, total: data.total });
    } catch (err: any) {
      setSyncError(err.message || "Sync failed");
    } finally {
      setSyncing(false);
    }
  }

  return (
    <div>
      <PageHeader title="Settings" description="System configuration and tools" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        <Card title="Tracking Sync">
          <p className="text-sm text-gray-600 mb-4">
            Sync all offer configurations to the tracking worker's edge cache (KV). Use this after deployments or if tracking links return "offer not found".
          </p>

          {syncResult && (
            <div className="flex items-center gap-2 mb-4 p-3 rounded-lg bg-green-50 border border-green-200">
              <CheckCircle2 className="w-4 h-4 text-green-600 shrink-0" />
              <span className="text-sm text-green-800">
                Synced {syncResult.synced}/{syncResult.total} offers{syncResult.failed > 0 ? ` (${syncResult.failed} failed)` : ""}
              </span>
            </div>
          )}

          {syncError && (
            <div className="flex items-center gap-2 mb-4 p-3 rounded-lg bg-red-50 border border-red-200">
              <XCircle className="w-4 h-4 text-red-600 shrink-0" />
              <span className="text-sm text-red-800">{syncError}</span>
            </div>
          )}

          <button
            onClick={handleSyncOffers}
            disabled={syncing}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg hover:bg-gray-800 disabled:opacity-50"
          >
            <RefreshCw className={`w-4 h-4 ${syncing ? "animate-spin" : ""}`} />
            {syncing ? "Syncing..." : "Sync Offers to Tracking"}
          </button>
        </Card>
      </div>
    </div>
  );
}
